import Card from '../..';
import { Enum_Bookmark_Category, Resource } from '@edwin-group/cj-graphql';
import { getAuthors } from '@/services/resource-hub/utils';
import DefaultContentTemplateTags from '@/components/DefaultContentTemplate/Tags';
import Button from '@/components/Button';
import { useNavigate } from 'react-router-dom';
import BookmarkButton from '@/components/Bookmark/BookmarkButton';
import isPodcastDone from '@/pages/resource-hub/resource/utils/is-done';

const arrowPodcastImg = '/card/arrow-podcast.png';
const playIcon = '/card/play-icon.png';

const PodcastCard = ({
  resource,
  buttonText = 'Play',
  showBookmarkIcon,
  onRemoveFromBookmark,
}: {
  resource: Resource;
  buttonText?: string;
  showBookmarkIcon?: boolean;
  onRemoveFromBookmark?: () => void;
}) => {
  const navigate = useNavigate();

  const { progress } = isPodcastDone(resource);
  const CardButton = () => {
    const link = `/resource-hub/resource/${resource.slug}`;

    return (
      <div className="rows-span-1 flex flex-col items-start gap-1">
        <Button
          theme="solid-primary-600"
          onClick={() => {
            if (link) {
              navigate(link);
            }
          }}>
          <img src={playIcon} className="h-auto w-[12px]" alt="play icon" />
          {buttonText}
        </Button>
      </div>
    );
  };

  return (
    <Card
      key={resource?.slug}
      title={resource.title || ''}
      description={resource.briefDescription || ''}
      author={getAuthors(resource)}
      arrowImg={arrowPodcastImg}
      tags={
        <DefaultContentTemplateTags
          tags={[resource?.resourceType?.type?.toString() || '']}
          className="!mb-2 !mt-0"
          duration={resource?.duration || undefined}
        />
      }
      progress={progress}
      image={{
        url: resource.cover.url || '',
        alternativeText: resource.cover.alternativeText || '',
      }}
      button={<CardButton />}
      bookmarkButton={
        showBookmarkIcon ? (
          <BookmarkButton
            relationId={resource?.documentId || ''}
            metadata={resource as Resource}
            category={Enum_Bookmark_Category.Resource}
            onRemoveFromBookmark={onRemoveFromBookmark}
            typeId={resource?.resourceType?.documentId || ''}
          />
        ) : null
      }
    />
  );
};

export default PodcastCard;
